import axiosHandler from "interceptor/axiosInterceptor";

export const getFacilities = async (params) => {
  try {
    const response = await axiosHandler.get("/api/admin/facilities", { params });
    return response;
  } catch (error) {
    throw error;
  }
};

export const getFacilityById = async (id) => {
  try {
    const response = await axiosHandler.get(`/api/admin/facilities/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const createFacility = async (data) => {
  try {
    const response = await axiosHandler.post("/api/admin/facilities", data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateFacility = async (id, data) => {
  try {
    const response = await axiosHandler.put(`/api/admin/facilities/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const assignOwner = async (facilityId, athleteId) => {
  try {
    const response = await axiosHandler.post(
      `/api/admin/facilities/${facilityId}/assign-owner`,
      { athlete_id: athleteId }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const unassignOwner = async (facilityId) => {
  try {
    const response = await axiosHandler.delete(
      `/api/admin/facilities/${facilityId}/owner`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const toggleBookable = async (facilityId, value) => {
  try {
    const response = await axiosHandler.patch(
      `/api/admin/facilities/${facilityId}/bookable`,
      { is_bookable: value }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateFacilityStatus = async (facilityId, status) => {
  try {
    const response = await axiosHandler.patch(
      `/api/admin/facilities/${facilityId}/status`,
      { status }
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getActivities = async (facilityId) => {
  try {
    const response = await axiosHandler.get(
      `/api/admin/facilities/${facilityId}/activities`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const createActivity = async (facilityId, data) => {
  try {
    const response = await axiosHandler.post(
      `/api/admin/facilities/${facilityId}/activities`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const updateActivity = async (facilityId, activityId, data) => {
  try {
    const response = await axiosHandler.put(
      `/api/admin/facilities/${facilityId}/activities/${activityId}`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteActivity = async (facilityId, activityId) => {
  try {
    const response = await axiosHandler.delete(
      `/api/admin/facilities/${facilityId}/activities/${activityId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getSlotSchedules = async (facilityId) => {
  try {
    const response = await axiosHandler.get(
      `/api/admin/facilities/${facilityId}/slots`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const upsertSlotSchedule = async (facilityId, data) => {
  try {
    const response = await axiosHandler.post(
      `/api/admin/facilities/${facilityId}/slots`,
      data
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const deleteSlotSchedule = async (facilityId, scheduleId) => {
  try {
    const response = await axiosHandler.delete(
      `/api/admin/facilities/${facilityId}/slots/${scheduleId}`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getManagers = async (facilityId) => {
  try {
    const response = await axiosHandler.get(
      `/api/admin/facilities/${facilityId}/managers`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const getFacilityRevenue = async (facilityId) => {
  try {
    const response = await axiosHandler.get(
      `/api/admin/facilities/${facilityId}/revenue`
    );
    return response;
  } catch (error) {
    throw error;
  }
};

export const searchAthletes = async (query) => {
  try {
    const response = await axiosHandler.get("/api/admin/users/athletes", {
      params: { search: query, limit: 10 },
    });
    return response;
  } catch (error) {
    throw error;
  }
};
